import styled from 'styled-components';

export const FileViewerImage = styled.img`
  max-width: 100%;
  object-fit: contain;
`;

export const FileViewerPDF = styled.iframe`
  width: 100%;
  height: calc(100% - 7px);
  object-fit: contain;
`;
